import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAlert from "../../../../hooks/useAlert";
import { validateBrandAdd } from "../../../../utils/validation";
import { addBrandAction } from "../../../../redux/actions/BrandAction";
import { IoMdSave } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import PropTypes from "prop-types";

export const BrandAdd = ({ openDialog, handleCloseDialog }) => {
  const { showSuccessBrandAdded, showErrorBrandAdded } = useAlert();
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const dispatch = useDispatch();
  const [value, setValue] = useState({});
  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValue((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const addBrand = async (e) => {
    e.preventDefault();
    value.userId = authUserId;
    value.ia = true;
    const errors = validateBrandAdd(value);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      try {
        await dispatch(addBrandAction(value, token));
        showSuccessBrandAdded();
        handleCloseDialog();
      } catch {
        showErrorBrandAdded();
      }
    }
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "95%", sm: "500px" },
          maxWidth: "500px",
          margin: { xs: 2, sm: 4 },
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          color: "black",
          fontWeight: "bold",
          textAlign: "center",
          padding: { xs: 1.5, sm: 2 },
          marginBottom: { xs: 2, sm: 3 },
          fontSize: { xs: "1.1rem", sm: "1.25rem" },
        }}
      >
        + Marka kaydet
      </DialogTitle>
      <DialogContent sx={{ padding: { xs: 2, sm: 3 } }}>
        <Grid container spacing={{ xs: 1.5, sm: 2 }}>
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              label="Marka ismi"
              variant="outlined"
              placeholder="Marka ismi"
              value={value.name}
              name="name"
              onChange={handleInputChange}
              error={!!formErrors.name}
              helperText={formErrors.name}
              sx={{
                "& .MuiOutlinedInput-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ padding: { xs: 2, sm: 3 } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 1.5, sm: 1 },
            justifyContent: "flex-end",
            width: "100%",
            mt: { xs: 1, sm: 2 },
          }}
        >
          <Button
            onClick={handleCloseDialog}
            sx={{
              borderRadius: 2,
              border: "1px solid #1F1B45",
              color: "#1F1B45",
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.813rem", sm: "0.875rem" },
              padding: { xs: "8px 16px", sm: "6px 12px" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#F3F3F3",
                border: "1px solid #2C285A",
                color: "#2C285A",
              },
            }}
            size="small"
            variant="outlined"
          >
            İptal
          </Button>
          <Button
            onClick={addBrand}
            sx={{
              borderRadius: 2,
              backgroundColor: "#1F1B45",
              color: "#fff",
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.813rem", sm: "0.875rem" },
              padding: { xs: "8px 16px", sm: "6px 12px" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#2C285A",
              },
            }}
            size="small"
            variant="contained"
          >
            Kaydet
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

BrandAdd.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
};
